import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "qsharp",
  extensions: [".qs"],
  aliases: ["Q#", "qsharp"],
  loader: () => import('./qsharp.js')
});
